import { EstablishmentAllowedClientCompanyData } from "../types/establishmentAllowedClientCompanies.type";

export class EstablishmentAllowedClientCompaniesTransformer {
  static optionsTransformer() {
    return (allowedCompanies: EstablishmentAllowedClientCompanyData[]) => {
      return allowedCompanies.map((allowedCompany) => {
        return {
          value: allowedCompany.client_company.id,
          label: allowedCompany.client_company?.general_information?.fantasy_name || '',
        };
      });
    };
  }
}
